import RMNCarousel from 'components/Rmn/RMNCarousel/RMNCarousel';
import { withRMNCarouselProps } from 'viewModel/rmn/rmnCarousel/withRMNCarouselProps';

const ConnectedRMNCarousel = withRMNCarouselProps(RMNCarousel);

export default ConnectedRMNCarousel;
